import { render, staticRenderFns } from "./ExamDirectionBreadcrumb.vue?vue&type=template&id=a24b3d6a&scoped=true&"
import script from "./ExamDirectionBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ExamDirectionBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24b3d6a",
  null
  
)

export default component.exports